import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Transforms } from 'slate';
import TableUtils from '../TableUtils';
import { getTableStructureFromElement } from '../TableStructure';

class ToolTableHeader extends Tool {
  static headerType: 'table_headerRow' | 'table_headerColumn';

  static action({ editor }: ToolArgs): void {
    if (!editor.selection) return;

    const tableEntry = TableUtils.currentTable(editor);
    if (!tableEntry) return;

    if (tableEntry[0][this.headerType]) {
      Transforms.unsetNodes(editor, this.headerType, {
        at: tableEntry[1],
      });
    } else {
      Transforms.setNodes(
        editor,
        { [this.headerType]: true },
        {
          at: tableEntry[1],
        }
      );
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return Boolean(tableElement[this.headerType]);
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return true;
  }
}

// Toggle the header row for a table.
class ToolTableHeaderRow extends ToolTableHeader {
  static toolName = 'Header row';
  static iconClass = 'fa-regular fa-table-columns';
  static headerType = 'table_headerRow' as const;

  static isEnabled(toolArgs: ToolArgs): boolean {
    const { editor } = toolArgs;

    if (!editor?.selection) return false;

    const currentTable = TableUtils.currentTable(editor);
    if (!currentTable) return false;

    if (!currentTable[0].table_headerRow) {
      const tableStructure = getTableStructureFromElement(
        editor,
        currentTable[0]
      );
      if (!tableStructure) return false;

      for (const { cell, rowIndex } of tableStructure.cellsInTable()) {
        if (!cell) continue;
        if (rowIndex > 0) break;

        if ((cell.tableCell.table_rowspan ?? 1) > 1) {
          return false;
        }
      }
    }

    return super.isEnabled(toolArgs);
  }
}

// Toggle the header column for a table.
class ToolTableHeaderColumn extends ToolTableHeader {
  static toolName = 'Header column';
  static iconClass = 'fa-regular fa-table-rows';
  static headerType = 'table_headerColumn' as const;
}

export { ToolTableHeaderRow, ToolTableHeaderColumn };
